module.exports = __webpack_public_path__ + "img/search_01.8df78c71.png";